import React, { useEffect, useState } from "react";
import { Card, CardContent, Grid, Typography, Checkbox, FormControlLabel, Box } from '@mui/material';
import SignatureUpload from './SignatureUpload';
import { useDispatch, useSelector } from "react-redux";
import TCActionsTypes from "../../redux/actions/TestingCommission/TCActionTypes";
import { DispatchAction, setOthersDetailsFields } from "../../redux/actions/TestingCommission/dispatchActions";
import AssetFooter from "../commoncomponents/AssetFooter";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import { tcCreateUpdateRepository } from "../../api/repositories/TestingandCommissioning/tcCreateUpdateRepository";
// import { useNavigate } from "react-router-dom";
import ComponentHeader from "../commoncomponents/ComponentHeader";
import { mandatoryFields } from "../../redux/actions/assetActions";
import { useLocation, useNavigate } from "react-router-dom";
const TCOthers = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { stepper } = useSelector(state => state.TestingCommissionDetails.stepper);
  // const othersDetails= useSelector(state => state.TestingCommissionDetails.othersDetails);

  // const othersDetails ={...othersDetailsField,...location.state.basicDetailsFieldValueTcOthers}
 let tcDetails= useSelector(state => state.TestingCommissionDetails.tcDetails); 
    let checkFields=tcDetails;
  tcDetails=( tcDetails?.id === '')?location.state.tcDetails:tcDetails;


    let othersDetails = useSelector((state) => state.TestingCommissionDetails.othersDetails);
     othersDetails= location.state.TcOthers==undefined?othersDetails:location.state.TcOthers;
  //get the common testing and commission details from redux
  // const tcDetails = useSelector(state => state.TestingCommissionDetails.tcDetails);
  // const tcDetails={...tcDetailsField,...location.state.basicDetailsFieldValueTcOthers}

  // const basicDetails = useSelector(state => state.TestingCommissionDetails.basicDetails);
  let basicDetails = useSelector(state => state?.TestingCommissionDetails?.basicDetails);
  basicDetails=( basicDetails?.id === '')?location.state.basicDetails:basicDetails;
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [initialOthersDetails, setInitialOthersDetails] = useState({});
  const [isDisableAllfileds, setIsDisableAllfileds] = useState(false);
  const [isVendorLogin, setIsVendorLogin] = useState(localStorage.getItem("roleName") === "Vendors"?true:false);
  const [isDataChanged, setIsDataChanged] = useState(false);
  // dropdown declarations
  const proofOptions = [
    { value: true, label: 'YES' },
    { value: false, label: 'NO' }
  ];

  //state declarations
  const [rows, setRows] = useState([
    {
      id: 1,
      name: '',
      designation: '',
      fileType: '',
      size: '',
      date: '',
      signature: '',
      fileSignature: '',
    }
  ]);

  useEffect(() => {
    if (rows?.length === 0) {
      setRows([{ id: 1, name: '', designation: '', fileType: '', size: '', date: '', signature: '', fileSignature: '' }]);
    }
  }, [rows]);

  const handleSwitchChange = () => {
    // Access the checked state of the switch using event.target.checked
    // Perform actions based on the switch state (isChecked)
    dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
  };

  useEffect(() => {
    handleSwitchChange(); //for issue no:IF-692 i have handled this switch change whithout changing the common component
    if (tcDetails?.isViewMode) {
      setIsDisableAllfileds(true);
    }
    if (tcDetails?.isVendorLogin) {
      setIsVendorLogin(true);
    }
    setInitialOthersDetails(othersDetails);
  }, []);

  //onchange function for dropdown
  const handleDropdownChange = (category, field) => (value) => {
    navigate(location.pathname, {
      state: {
        ...location.state,
        TcOthers:{...location.state?.TcOthers,[field]: value,}
      }
  });
    dispatch(setOthersDetailsFields({
      [field]: value,
    }));
  };

  //onchange function for checkbox
  const handleCheckboxChange = (category, field) => (event) => {
    const newValue = event.target.checked;
    setIsDataChanged(true);
    navigate(location.pathname, {
      state: {
        ...location.state,
        TcOthers:{...location.state?.TcOthers,  [category]: {
          ...othersDetails[category],
          [field]: newValue,
        },}
      }
  });

    dispatch(setOthersDetailsFields({
      [category]: {
        ...othersDetails[category],
        [field]: newValue,
      }
    }));
  };

  // Check if any data has changed
  const checkStatus = (status) => {
    if (basicDetails?.isEditMode) {
      const id = tcDetails?.femtestingcommissionstatusId || tcDetails?.bemtestingcommissionstatusId;
      const statuses = {
        3: { Testcommissionstatus: 'Submitted', id: 3 },
        5: { Testcommissionstatus: 'Authorized', id: 5 },
        6: { Testcommissionstatus: 'Rejected', id: 6 }
      };

      const oldDetails = initialOthersDetails;
      const newDetails = othersDetails;
      // Check if any data has changed
      const hasDataChanged = (oldDetails && newDetails) ? Object.keys(oldDetails).some(key => oldDetails[key] !== newDetails[key]):'';
      if (hasDataChanged) {
        return status;
      } else {
        return statuses[id] || status;
      }
    }
    return status;
  };

  const getTrueKeys = (obj) => {
    return obj ? Object?.keys(obj)?.filter(key => obj[key])?.join(',') : '';
  };

  const handleContinueClick = () => {
    const data = 'Attachments';
    dispatch(DispatchAction(TCActionsTypes.NEXT_PAGE, { ...stepper, currentPage: data }));
  };

  const handleNextClick = async () => {
    const othersDetailsPayload = {
      class: getTrueKeys(othersDetails?.class),
      powercord: getTrueKeys(othersDetails?.powerCard),
      isdefibrillationproof: othersDetails?.proof ? othersDetails?.proof?.value : "",
      referenceno: getTrueKeys(othersDetails?.referenceNo),
      type: getTrueKeys(othersDetails?.type),
    };
    let processingpercentage = tcDetails?.processingpercentage;
    if (processingpercentage > 35) {
      // Do nothing, keep the existing value
    } else {
      processingpercentage = 70;
    }
    const payload = { ...basicDetails, ...othersDetailsPayload, processingpercentage }
    const id = tcDetails?.id;
    const serviceType = basicDetails?.service?.label;
    const status = {
      Testcommissionstatus: 'In-Progress',
      id: 2
    }
    const isStatusAthorizedorRejected = checkStatus(status);
    const response = await tcCreateUpdateRepository?.updateTC(payload, id, serviceType, isStatusAthorizedorRejected);
    if (response?.id) {
      const data = 'Attachments';
      dispatch({ type: TCActionsTypes?.SET_TC_FIELD_VALUES, payload: response });
      dispatch(DispatchAction(TCActionsTypes.NEXT_PAGE, { ...stepper, currentPage: data }));
    } else {
      console.log('error');
    }
  };


  const handlePreviousClick = () => {
    const data = 'Basic Details';
    dispatch(DispatchAction(TCActionsTypes.PREVIOUS_PAGE, { ...stepper, currentPage: data }));
  };

  const handleSaveSignature = async (id, data) => {
    // Update the row with the new signature
    const updatedRows = rows.map((row) =>
      row.id === id ? { ...row, ...data, fileSignature: data.file } : row
    );
    setRows(updatedRows);
    setOpenDialog(false); // Close the dialog box
    return updatedRows;
  };
  const statusId = (tcDetails?.femtestingcommissionstatusId || tcDetails?.bemtestingcommissionstatusId);
  const statusArray = [
    { id: 1, value: 'open' },
    { id: 2, value: 'inprogress' },
    { id: 3, value: 'submitted' },
    { id: 4, value: 'completed' },
    { id: 5, value: 'authorized' },
    { id: 6, value: 'rejected' },
  ];
  const status = statusId ? statusArray?.find((item) => item?.id === statusId)?.value : '';

  return (
    <Card sx={{ boxShadow: 'none' }}>
      <ComponentHeader
        mainHeader={"Other Details"}
        subHeader={"Please provide the below details"}
        statusType={status}
        assetvalue={tcDetails?.testingcommissionno}
        requiredButton={false}
      />
      <CardContent sx={{ marginTop: '0rem' }}>
        <Typography variant="subtitle1" align="left">Reference no</Typography>
        <Grid container spacing={8} sx={{ marginBottom: '1rem' }}>
          <Grid item xs={2.4}>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={isDisableAllfileds}
                  checked={othersDetails?.referenceNo?.IEC61010}
                  onChange={handleCheckboxChange('referenceNo', 'IEC61010')}
                />
              }
              label="IEC 61010"
            />
          </Grid>
          <Grid item xs={2.4}>
            <FormControlLabel
              control={<Checkbox disabled={isDisableAllfileds} checked={othersDetails?.referenceNo?.IEC60601} onChange={handleCheckboxChange('referenceNo', 'IEC60601')} />}
              label="IEC 60601"
            />
          </Grid>
          <Grid item xs={2.4}>
            <FormControlLabel
              control={<Checkbox disabled={isDisableAllfileds} checked={othersDetails?.referenceNo?.IEC60950} onChange={handleCheckboxChange('referenceNo', 'IEC60950')} />}
              label="IEC 60950"
            />
          </Grid>
        </Grid>

        <Typography variant="subtitle1" align="left">Class</Typography>
        <Grid container spacing={8} sx={{ marginBottom: '1rem' }}>
          <Grid item xs={2.4}>
            <FormControlLabel
              control={<Checkbox disabled={isDisableAllfileds} checked={othersDetails?.class?.class1} onChange={handleCheckboxChange('class', 'class1')} />}
              label="Class 1"
            />
          </Grid>
          <Grid item xs={2.4}>
            <FormControlLabel
              control={<Checkbox disabled={isDisableAllfileds} checked={othersDetails?.class?.class2} onChange={handleCheckboxChange('class', 'class2')} />}
              label="Class 2"
            />
          </Grid>
          <Grid item xs={2.4}>
            <FormControlLabel
              control={<Checkbox disabled={isDisableAllfileds} checked={othersDetails?.class?.class3} onChange={handleCheckboxChange('class', 'class3')} />}
              label="Class 3"
            />
          </Grid>
          <Grid item xs={2.4}>
            <FormControlLabel
              control={<Checkbox disabled={isDisableAllfileds} checked={othersDetails?.class?.IP} onChange={handleCheckboxChange('class', 'IP')} />}
              label="IP"
            />
          </Grid>
          <Grid item xs={2.4}>
            <FormControlLabel
              control={<Checkbox disabled={isDisableAllfileds} checked={othersDetails?.class?.NA} onChange={handleCheckboxChange('class', 'NA')} />}
              label="N/A"
            />
          </Grid>
        </Grid>

        <Typography variant="subtitle1" align="left">Type</Typography>
        <Grid container spacing={8} sx={{ marginBottom: '1rem' }}>
          <Grid item xs={2.4}>
            <FormControlLabel
              control={<Checkbox disabled={isDisableAllfileds} checked={othersDetails?.type?.B} onChange={handleCheckboxChange('type', 'B')} />}
              label="B"
            />
          </Grid>
          <Grid item xs={2.4}>
            <FormControlLabel
              control={<Checkbox disabled={isDisableAllfileds} checked={othersDetails?.type?.BF} onChange={handleCheckboxChange('type', 'BF')} />}
              label="BF"
            />
          </Grid>
          <Grid item xs={2.4}>
            <FormControlLabel
              control={<Checkbox disabled={isDisableAllfileds} checked={othersDetails?.type?.CF} onChange={handleCheckboxChange('type', 'CF')} />}
              label="CF"
            />
          </Grid>
          <Grid item xs={2.4}>
            <FormControlLabel
              control={<Checkbox disabled={isDisableAllfileds} checked={othersDetails?.type?.NA} onChange={handleCheckboxChange('type', 'NA')} />}
              label="N/A"
            />
          </Grid>
        </Grid>

        <Typography variant="subtitle1" align="left">Power cord</Typography>
        <Grid container spacing={2.5} sx={{ marginBottom: '1rem' }}>
          <Grid item xs={2.5}>
            <FormControlLabel
              control={<Checkbox disabled={isDisableAllfileds} checked={othersDetails?.powerCard?.nonDetachable} onChange={handleCheckboxChange('powerCard', 'nonDetachable')} />}
              label="Non-Detachable"
            />
          </Grid>
          <Grid item xs={2.5}>
            <FormControlLabel
              control={<Checkbox disabled={isDisableAllfileds} checked={othersDetails?.powerCard?.detachable} onChange={handleCheckboxChange('powerCard', 'detachable')} />}
              label="Detachable"
            />
          </Grid>
          <Grid item xs={2.5}>
            <FormControlLabel
              control={<Checkbox disabled={isDisableAllfileds} checked={othersDetails?.powerCard?.strainRelief} onChange={handleCheckboxChange('powerCard', 'strainRelief')} />}
              label="Strain Relief"
            />
          </Grid>
          <Grid item xs={2.5}>
            <FormControlLabel
              control={<Checkbox disabled={isDisableAllfileds} checked={othersDetails?.powerCard?.medicalGrade}
                onChange={handleCheckboxChange('powerCard', 'medicalGrade')} />}
              label="Medical Grade"
            />
          </Grid>
        </Grid>

        <Grid item xs={4}>
          <Typography variant="subtitle1" align="left">
            Defibrillation proof
          </Typography>
        </Grid>

        <Grid container spacing={3} sx={{ marginBottom: '3rem' }}>
          <Grid item xs={4}>
            <CustomSelectInput
              disabled={isDisableAllfileds}
              isMandatoryField={false}
              id="proof"
              defaultValue="option1"
              options={proofOptions}
              onChange={handleDropdownChange('otherDetails', 'proof')}
              value={othersDetails?.proof || ''}
            />
          </Grid>
        </Grid>
        <SignatureUpload handleSaveSignature={handleSaveSignature} rows={rows} setRows={setRows} openDialog={openDialog} setOpenDialog={setOpenDialog} />
        <AssetFooter
          onPreviousClick={handlePreviousClick}
          onNextClick={handleNextClick}
          showSubmit={false}
          showAuthorize={false}
          showNext={!isDisableAllfileds}
          continueButtonName="Back"
          nextButtonTitle="Continue to Attachments"
          showCancel={true}
          dataChanged={isDataChanged}
          isVendorLogin={isVendorLogin}
          cancelButtonName="Cancel"
          handlCancelClick={() => {
            if (!isVendorLogin) {
              navigate('/testingcommission')
            } else if (isVendorLogin) {
              navigate('/VendorDashboard')
            }
          }}
          showReject={false}
          showConvertToAsset={false}
          previous={true}
          continueNext={isDisableAllfileds}
          continueButtonTitle={"NEXT"}
          onContinueClick={handleContinueClick}
        />
      </CardContent>
    </Card>
  );
};

export default TCOthers;
